import React from 'react'

export const CaretDownIcon = ({ $dark }: { $dark: boolean }) => {
    return (
        <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 0.999878L7.5 6.99988L1 0.999877" stroke={$dark ? 'black' : 'white'} strokeWidth="2" />
        </svg>
    )
}
